export const DEFAULT_PROJECT_ORDERING = "-created"

export const UNKNOWN_CREATOR = "Unknown"

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

// A backend older than EAD-651 sends the creator's id here, never a name.
export const creatorLabel = (name?: string | null): string =>
  name && !UUID.test(name) ? name : UNKNOWN_CREATOR

// Keys are the server's preset vocabulary; "This Year" is its `ytd`, the same
// rows for creation data since nothing is created in the future.
export const CREATED_DATE_PRESETS = [
  { key: "this_month", label: "This Month" },
  { key: "this_quarter", label: "This Quarter" },
  { key: "ytd", label: "This Year" },
  { key: "last_month", label: "Last Month" },
  { key: "last_quarter", label: "Last Quarter" },
  { key: "last_year", label: "Last Year" }
]

export const CREATED_DATE_FILTER_FIELD = {
  type: "presetrange",
  key: "created_after",
  endKey: "created_before",
  presetKey: "created_window",
  presets: CREATED_DATE_PRESETS,
  label: "Created date",
  placeholder: "Created date: all time",
  allTimeLabel: "All time",
  customLabel: "Custom Range"
} as const
